import { BsUtilReceivers } from "../../dependencies";
import { SendMessageType } from "../../types";
import { restrictedSportIds } from "../../constants";
import { storeItems } from "../../helpers";
export function addQuickBetslipId(config) {
    let messageType = config.messageType;
    if (config.selectionsCount === 0 && config.items.length === 1) {
        setMessage(messageType, config.messageCache, config.items);
    }
    else if (config.selectionsCount === 1) {
        if (messageType === SendMessageType.Add) {
            messageType = SendMessageType.Clear;
        }
        setMessage(messageType, config.messageCache, config.items);
    }
}
function setMessage(messageType, messageCache, items) {
    if (messageType === SendMessageType.Clear || !isSportRestricted(items, restrictedSportIds)) {
        messageCache[messageType].receiverIds.push(BsUtilReceivers.QuickBetSlip);
        storeItems(messageType, messageCache, items);
    }
}
function isSportRestricted(items, restrictedSportIds) {
    return items.some(i => {
        return i.sportId && restrictedSportIds.indexOf(i.sportId) >= 0;
    });
}
//# sourceMappingURL=addQuickBetslipId.js.map